/**
 * Reports → Contact Center Report → Agent Reports → Agent Productivity Per Interval.
 *
 * Interval-level totals per agent/campaign: calls, talk/handle/hold/wait times,
 * and the agent's logged-in state time.
 */
import type { JSX } from 'react'
import { Headset } from 'lucide-react'

import AgentProductivityPerIntervalAnalytics from '../../../components/reports/calls/AgentProductivityPerIntervalAnalytics.js'
import {
  AGENT_PRODUCTIVITY_PER_INTERVAL_COLUMNS,
  AGENT_PRODUCTIVITY_PER_INTERVAL_REPORT_ID,
} from '../../../components/reports/calls/columns.js'
import CallReportPage from './CallReportPage.js'

export default function AgentProductivityPerIntervalReportPage(): JSX.Element {
  return (
    <CallReportPage
      Icon={Headset}
      title="Agent Productivity Per Interval"
      intro="Agent call activity and state time, bucketed by interval."
      unit="interval"
      path="/reports/calls/agent-productivity-per-interval"
      reportId={AGENT_PRODUCTIVITY_PER_INTERVAL_REPORT_ID}
      catalog={AGENT_PRODUCTIVITY_PER_INTERVAL_COLUMNS}
      fields={['campaigns', 'agents']}
      windowNote="The window is on the time the call started and agent status was recorded."
      searchPlaceholder="Search agents, campaigns or intervals…"
      renderAnalytics={(rows) => <AgentProductivityPerIntervalAnalytics rows={rows} />}
      emptyDescription="Choose a start date, an end date and an interval in Filters, then run the report."
      noResultsTitle="No productivity in this window"
      noResultsDescription="No agent activity was recorded in the selected scope. Try widening the window or clearing the filters."
    />
  )
}
